var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"tooltip",attrs:{"id":"tooltip"}}),_c('div',{staticClass:"div_imgXml",domProps:{"innerHTML":_vm._s(_vm.imgXml)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }